const styles = {
  city: {
    borderBottom: `solid 1px rgb(238, 238, 238)`,
    color: `rgb(153, 153, 153)`,
    fontSize: 14,
    paddingBottom: 15
  },
  container: {
    color: `rgb(51, 51, 51)`,
    boxShadow: `rgba(0, 0, 0, 0.05) 0px 1px 1px`,
    display: `flex`,
    flex: 1,
    flexDirection: `column`,
    marginTop: 40,
    padding: 30
  },
  tab: {
    color: `rgb(50, 118, 177)`,
    fontSize: 12,
    lineHeight: `20px`,
    marginTop: 10
  },
  tabContent: {
    color: `rgb(51, 51, 51)`,
    fontSize: `12`,
    paddingTop: 15
  },
  title: {
    color: `rgb(51, 51, 51)`,
    fontSize: 22,
    fontWeight: 300
  },
  subTitle: {
    color: `rgb(51, 51, 51)`,
    fontSize: 12,
    fontWeight: "bold"
  }
};

export default styles;
